export default __webpack_public_path__ + "static/media/Image3.08a932e5.png";